import React from 'react';

const SidebarOption = (props) => {

  let handleClick = () => { };

  let clDisabled = '';
  if (props.disabled === true) {
    clDisabled = ' option--disabled';
  } else {
    if (typeof props.handleClick === 'function') {
      handleClick = props.handleClick;
    }
  }

  let clActive = '';
  if (props.active === true) {
    clActive = ' active';
  }
  let hasIcon = false;
  let jsxFontAwsome = null;
  jsxFontAwsome = (
    <span className="icon">
      <i></i>
    </span>
  );
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <span className="icon">
        <i className={props.i} aria-hidden="true"></i>
      </span>
    )
  }

  return (
    <div
      className={"option" + clActive + clDisabled}
      onClick={handleClick}
    >
      <div className="bg">{jsxFontAwsome}<span className="title">{props.title}</span></div>
    </div>
  );
};

export default SidebarOption;